module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom18.66f42798.jpg";